import { Controller } from "@hotwired/stimulus"
import { createFocusTrap } from "focus-trap"

export default class extends Controller {
  static targets = ["modalDialog", "modalWrapper"]
  static values = {
    delay: Number,
    onLoad: Boolean,
    clickOutsideDeactivates: { type: Boolean, default: true },
  }

  connect() {
    if (this.onLoadValue) {
      setTimeout(() => {
        this.show()
      }, this.delayValue * 1000)
    }
  }

  disconnect() {
    if (this.focusTrap) {
      this.focusTrap.deactivate()
      this.hide()
    }
  }

  show(event) {
    const modal = !!event?.params?.id
      ? this.modalWrapperTargets.find((target) => target.id === event.params.id)
      : this.modalWrapperTarget

    modal.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")

    this.focusTrap = createFocusTrap(modal, {
      clickOutsideDeactivates: this.clickOutsideDeactivatesValue,
      escapeDeactivates: true,
    })

    this.focusTrap.activate()
  }

  hide() {
    const modal = this.modalWrapperTargets.find((target) => !target.classList.contains("hidden"))

    modal.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
    if (this.focusTrap) {
      this.focusTrap.deactivate()
    }
  }
}
